//- 控制开关,dev、test、prod
var ENV = process.env.JOSH_ENV;

var link = {
	dev: {
		website: 'http://192.168.3.163:8081/',
		community: 'http://192.168.3.125:8010/forum.php',
		document: 'http://192.168.3.163:8001/',
		visual: 'http://localhost:8080/',
	},
	test: {
		website: 'http://118.190.93.145:8032/',
		community: 'http://192.168.3.125:8010/forum.php',
		document: 'http://118.190.93.145:8043/',
		visual: 'http://localhost:8080/',
	},
	prod: {
		website: 'https://www.joshvm.com/',
		community: 'https://community.joshvm.com/',
		document: 'https://doc.joshvm.com/',
		visual: 'https://jisvsl.joshvm.com/',
	}
}

export default {
	links: link[ENV]
}


// WEBPACK FOOTER //
// ./src/options/base.js